<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #paymentTermForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="paymentTerm.id">{{ l('EditPaymentTerm') }}</span>

                        <span *ngIf="!paymentTerm.id">{{ l('CreateNewPaymentTerm') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="PaymentTerm_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #PaymentTerm_Name="ngModel"
                            id="PaymentTerm_Name"
                            class="form-control"
                            [(ngModel)]="paymentTerm.name"
                            name="Name"
                            minlength="0"
                            maxlength="100"
                            required
                        />
                        <validation-messages [formCtrl]="PaymentTerm_Name"></validation-messages>
                    </div>

                    <div class="my5">
                        <label class="form-label" for="PaymentTerm_NumberOfDays">{{ l('NumberOfDays') }}</label>
                        <input
                            type="number"
                            #PaymentTerm_NumberOfDays="ngModel"
                            id="PaymentTerm_NumberOfDays"
                            class="form-control"
                            [(ngModel)]="paymentTerm.numberOfDays"
                            name="NumberOfDays"
                        />
                        <validation-messages [formCtrl]="PaymentTerm_NumberOfDays"></validation-messages>
                    </div>

                    <div class="my5">
                        <label class="form-label" for="PaymentTerm_Discount">{{ l('Discount') }}</label>
                        <input
                            type="number"
                            #PaymentTerm_Discount="ngModel"
                            id="PaymentTerm_Discount"
                            class="form-control"
                            [(ngModel)]="paymentTerm.discount"
                            name="Discount"
                        />
                        <validation-messages [formCtrl]="PaymentTerm_Discount"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="PaymentTerm_PayBy">{{ l('PayBy') }}</label>
                        <input
                            type="text"
                            #PaymentTerm_PayBy="ngModel"
                            id="PaymentTerm_PayBy"
                            class="form-control"
                            [(ngModel)]="paymentTerm.payBy"
                            name="PayBy"
                        />
                        <validation-messages [formCtrl]="PaymentTerm_PayBy"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!paymentTermForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
